
import React from 'react'

export const Title = ({ name, containerClassname }) => {
    return <div className={`${containerClassname} mt-0`}> <h3>{name}</h3></div>
}
